import { useCallback, useState } from 'react';

/**
 * Gerencia qual grupo tem popover aberto quando a sidebar está colapsada.
 * Só um popover pode estar aberto por vez.
 *
 * Versão simples (sem fade) — os popovers são renderizados inline e o
 * styled.js cuida do visual.
 *
 * @returns {{
 *   activeKey: string | null,
 *   openPopover: (key: string) => void,
 *   closePopover: () => void
 * }}
 */
export default function useActivePopover() {
   const [activeKey, setActiveKey] = useState(null);

   const openPopover = useCallback((key) => {
      setActiveKey((prev) => (prev === key ? null : key));
   }, []);

   const closePopover = useCallback(() => {
      setActiveKey(null);
   }, []);

   return { activeKey, openPopover, closePopover };
}
